var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocmediaArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.19526 12.4717C5.93491 12.2114 5.93491 11.7893 6.19526 11.5289L9.72386 8.00033L6.19526 4.47173C5.93491 4.21138 5.93491 3.78927 6.19526 3.52892C6.45561 3.26857 6.87772 3.26857 7.13807 3.52892L11.1381 7.52892C11.3984 7.78927 11.3984 8.21138 11.1381 8.47173L7.13807 12.4717C6.87772 12.7321 6.45561 12.7321 6.19526 12.4717Z",
    fill: "white",
    className: "white-fill-svg"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocmediaArrow);
export default __webpack_public_path__ + "static/media/socmedia-arrow.3887b4aef2b38ea32f3c563ff3bcd903.svg";
export { ForwardRef as ReactComponent };